import { match } from "ts-pattern";
import { cn } from "../../utils/class-names";
import { getOracle, OracleKey, OracleRiskLevel } from "@silo/types";

interface IndicatorProps {
  className?: string;
  riskLevel: OracleRiskLevel;
}

export function Indicator({
  className,
  riskLevel,
}: IndicatorProps): JSX.Element {
  return (
    <div
      className={cn(
        "w-3 h-3 rounded-full",
        match(riskLevel)
          .with("low", () => "bg-green-500")
          .with("moderate", () => "bg-amber-500")
          .exhaustive(),
        className
      )}
    />
  );
}
